<template>
  <div class="shop_box">
    <img :src="banner" class="banner" />
    <van-tabs v-model="active" @click="onClick">
      <van-tab v-for="index in timeList" :key="index.id" :title="index.batch_start_time_text">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="true"
        >
          <div
            class="shop-list"
            v-for="(item, index) in productList"
            :itemContent="item"
            :key="index"
            @click="goActDetails(item.id)"
          >
            <div class="shop">
              <img :src="item.images" alt class="shop_images" />
              <div class="shop_r">
                <div class="shop_g">
                  <span class="shop_t">特价</span>
                  <p class="shop_name">{{ item.goods_name }}</p>
                </div>
                <div class="shop_bottom">
                  <div class="shop_price_b">
                    <span class="shop_y">￥</span>
                    <span class="shop_activity_price">
                      {{
                      item.activity_price
                      }}
                    </span>
                    <del class="shop_y grey" style="margin-left: 10px">￥{{ item.market_price }}</del>
                  </div>
                  <div style="max-width: 120px; margin-top: 10px; overflow: hidden">
                    <van-progress
                      :percentage="item.surplus_ratio"
                      color="#f2826a"
                      :show-pivot="false"
                    />
                  </div>
                  <div class="shop_sales_b">
                    <span class="shop_sales">已抢{{ item.all_sales }}件</span>
                    <span class="shop_b">{{item.surplus_ratio == 100 ? '已抢光' : '马上抢'}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast } from 'vant'

Vue.use(Toast)
export default {
  name: 'shopList',
  data() {
    return {
      banner: null,
      active: 0,
      formData: {
        page: 1,
        activity_batch_id: 0,
        limit: 10,
        activity_id: 0,
      },
      pageNum: 1,
      activity_id: 0,
      productList: [],
      loading: false,
      finished: false,
      count: '', //总条数
      timeList: [],
      path: '',
    }
  },
  mounted() {
    this.getPlayNum()
    this.prohibitweixinShare()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == '/home') {
        vm.path = from.path
      }
    })
  },
  methods: {
    onClick(name, title) {
      console.log(this.timeList[name].id)
      console.log(this.active)
      this.formData.activity_batch_id = this.timeList[name].id
      this.formData.page = 1
      this.productList = []
      this.clientGoodsLIst()
    },
    onLoad() {
      this.formData.page++
      this.clientGoodsLIst()
    },
    // 跳转特价商品详情
    goActDetails(goods_id) {
      this.$router.push({
        path: '/activeShopDetail',
        query: { goods_id: goods_id, isActGoods: 'isAct' },
      })
      localStorage.setItem('activity_batch_id', this.formData.activity_batch_id)
      localStorage.setItem('shopListAlive', this.active)
    },
    getPlayNum() {
      this.activity_id = localStorage.getItem('activity_id')
      this.http('ClientGoods.getActivityBatchesList', {
        activity_id: this.activity_id,
      }).then((res) => {
        let that = this
        that.banner = res.content.banner
        that.formData.activity_id = that.activity_id
        res.content.list.forEach((item, i) => {
          that.timeList.push(item)
          if (that.path != '/home') {
            if (
              localStorage.getItem('activity_batch_id') &&
              localStorage.getItem('activity_batch_id') == item.id
            ) {
              that.active = JSON.parse(localStorage.getItem('shopListAlive'))
              that.formData.activity_batch_id = JSON.parse(
                localStorage.getItem('activity_batch_id')
              )
            } else {
              that.formData.activity_batch_id = res.content.list[0].id
            }
          } else {
            that.formData.activity_batch_id = res.content.list[0].id
          }
        })
        this.clientGoodsLIst()
      })
    },
    clientGoodsLIst() {
      this.http('ClientGoods.getActivityGoodsList', this.formData).then(
        (res) => {
          console.log(res)
          this.loading = false
          this.productList = this.productList.concat(res.content.list)
          this.finished = this.productList.length == res.content.count
          // if (res.statuss == 200 || res.msg == 'success') {
          // res.content.list.forEach((item, i) => {
          //   // item.percentage = item.sales / item.activity_stock
          //   this.productList.push(item)
          // })
          // this.loading = false
          // this.pageNum = Math.ceil(res.content.count / this.formData.limit)
          // if (this.formData.page < this.pageNum) {
          //   this.formData.page++
          //   this.clientGoodsLIst()
          // } else {
          //   this.finished = true
          // }
          // }
        }
      )
    },
  },
}
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 347px;
}
.van-tabs {
  position: relative;
  top: -14px;
}
.van-tab {
  top: -10px;
}
.van-tabs--line .van-tabs__wrap {
  height: 120px;
}
.van-tabs__nav--line {
  background-color: #8d0a00;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  height: 120px;
}
.van-tab__text--ellipsis {
  color: #fff;
  background-color: #8d0a00;
  font-size: 26px;
  border-radius: 16px;
  width: 98px;
  height: 32px;
  line-height: 34px;
  text-align: center;
}
.van-tabs__line {
  display: none;
}
.van-tab--active .van-tab__text--ellipsis {
  color: #e0231d;
  background-color: #fff;
}
.van-tabs__content {
  position: relative;
  top: -16px;
  background-color: #e0231d;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 30px;
}
.van-list__finished-text {
  color: #fff;
}
.shop-list .shop {
  padding: 20px;
  background-color: #fff;
  border-radius: 15px;
  overflow: hidden;
  .shop_images {
    border-radius: 15px;
    float: left;
    height: 240px;
    width: 240px;
  }
  .shop_r {
    position: relative;
    width: 59%;
    float: right;
    .shop_g {
      position: relative;
      color: #000000;
      .shop_t {
        width: 60px;
        height: 29px;
        background: linear-gradient(180deg, #ff3503 0%, #ff0152 100%);
        border-radius: 5px;
        color: #fff;
        font-size: 23px;
        padding: 2px 10px;
      }
      .shop_name {
        position: absolute;
        top: 2px;
        text-indent: 75px;
        font-size: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .shop_bottom {
      position: absolute;
      top: 110px;
      left: 0;
      right: 0;
      .shop_sales_b {
        height: 53px;
        overflow: hidden;
        .shop_sales {
          position: relative;
          top: 20px;
          color: #666666;
          font-size: 20px;
          float: left;
        }
        .shop_b {
          width: 106px;
          height: 53px;
          background: linear-gradient(90deg, #ff5f04 0%, #ff0331 100%);
          border-radius: 25px;
          color: #fff;
          font-size: 25px;
          line-height: 55px;
          float: right;
          text-align: center;
        }
      }
      .shop_price_b {
        .shop_activity_price {
          font-size: 35px;
          font-weight: bold;
          color: #fa3354;
        }
        .shop_y {
          color: #fa3354;
          font-size: 25px;
        }
        .shop_price {
          color: #9e9e9e;
          font-size: 25px;
        }
        .grey {
          color: #9e9e9e;
          font-size: 25px;
        }
      }
    }
  }
}
</style>
